export enum PaymentMethod {
  Pix = "pix",
  Credit = "credit_card",
  Debit = "debit_card",
}

export const paymentMethodLabelMap: Record<string, string> = {
  [PaymentMethod.Pix]: "Pix",
  [PaymentMethod.Credit]: "Crédito",
  [PaymentMethod.Debit]: "Débito",
};
